export const RULE_STATE = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
})

export const LOAD_ALL_RULES_QUERYID = 'entityType:rule pageSize:10000'
